export type Game = {
  game_name: string;
  display_name: string;
  itunes_url: string;
  play_url: string;
  image_url: string;
};

export const GAME_LIST = [
  {
    game_name: 'dank_balls',
    display_name: 'Dank Balls',
    itunes_url: 'https://apps.apple.com/us/app/dank-balls/id1486388232',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankballs',
    image_url: 'https://cdn.harbor.lol/assets/606d843c9e37491b1c77cb356e14646f',
  },
  {
    game_name: 'dank_maze',
    display_name: 'Dank Maze',
    itunes_url: 'https://apps.apple.com/us/app/dank-maze/id1485895251',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankmaze',
    image_url: 'https://cdn.harbor.lol/assets/43b7d10601cec9e683d3fddbb3cbeac2',
  },
  {
    game_name: 'dank_jumper',
    display_name: 'Dank Jumper',
    itunes_url: 'https://apps.apple.com/us/app/dank-jumper/id1486387829',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankjumper',
    image_url: 'https://cdn.harbor.lol/assets/602be30ae4ecc7804bbbe2dfe8db1502',
  },
  {
    game_name: 'dank_blaster',
    display_name: 'Dank Blaster',
    itunes_url: 'https://apps.apple.com/us/app/dank-blaster/id1485895457',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankblaster',
    image_url: 'https://cdn.harbor.lol/assets/696d1f16e22d9ce735d6b40afb25ccd3',
  },
  {
    game_name: 'dank_shooter',
    display_name: 'Dank Shooter',
    itunes_url: 'https://apps.apple.com/us/app/dank-shooter/id1486387862',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankshooter',
    image_url: 'https://cdn.harbor.lol/assets/91dc915d3030a26160f28be4602845d8',
  },
  {
    game_name: 'dank_anxiety',
    display_name: 'Dank Anxiety',
    itunes_url: 'https://apps.apple.com/us/app/dank-anxiety/id1485895405',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankanxiety',
    image_url: 'https://cdn.harbor.lol/assets/e7fd3bac5efe5936bc55622dbbb4ce68',
  },
  {
    game_name: 'dank_rocks',
    display_name: 'Dank Rocks',
    itunes_url: 'https://apps.apple.com/us/app/dank-rocks/id1485895536',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankrocks',
    image_url: 'https://cdn.harbor.lol/assets/9ddd4c24d5516f7ebb1d81abde43d6b2',
  },
  {
    game_name: 'dank_invaders',
    display_name: 'Dank Invaders',
    itunes_url: 'https://apps.apple.com/us/app/dank-invaders/id1486387978',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankinvaders',
    image_url: 'https://cdn.harbor.lol/assets/39f66cb18d30c48c518114fff98de804',
  },
  {
    game_name: 'dank_space',
    display_name: 'Dank Space',
    itunes_url: 'https://apps.apple.com/us/app/dank-space/id1486387888',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankspace',
    image_url: 'https://cdn.harbor.lol/assets/10f543fab9bee609a743a7a98f063dfb',
  },
  {
    game_name: 'dank_patrol',
    display_name: 'Dank Patrol',
    itunes_url: 'https://apps.apple.com/us/app/dank-patrol/id1486387920',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankpatrol',
    image_url: 'https://cdn.harbor.lol/assets/a2a5fdaddf9ab7bb1cea2fc6e1351221',
  },
  {
    game_name: 'dank_match',
    display_name: 'Dank Match',
    itunes_url: 'https://apps.apple.com/us/app/dank-match/id1486388385',
    play_url:
      'https://play.google.com/store/apps/details?id=lol.harbour.dankmatch',
    image_url: 'https://cdn.harbor.lol/assets/aaa3f50225532b5a94796a0b83c98ee7',
  },
];

export default {
  GAME_LIST,
};
